/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateTierForm } from '../models/CreateTierForm';
import type { Tier } from '../models/Tier';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DashboardTierRestControllerService {
    /**
     * @returns Tier OK
     * @throws ApiError
     */
    public static findTier({
        creatorId,
        id,
    }: {
        creatorId: number,
        id: number,
    }): CancelablePromise<Tier> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/{creatorId}/settings/tier/{id}',
            path: {
                'creatorId': creatorId,
                'id': id,
            },
        });
    }
    /**
     * @returns Tier OK
     * @throws ApiError
     */
    public static editTier({
        creatorId,
        id,
        requestBody,
    }: {
        creatorId: number,
        id: number,
        requestBody: Record<string, any>,
    }): CancelablePromise<Tier> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/dashboard/api/v1/{creatorId}/settings/tier/{id}',
            path: {
                'creatorId': creatorId,
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns Tier OK
     * @throws ApiError
     */
    public static deleteTier({
        creatorId,
        id,
    }: {
        creatorId: number,
        id: number,
    }): CancelablePromise<Tier> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/dashboard/api/v1/{creatorId}/settings/tier/{id}',
            path: {
                'creatorId': creatorId,
                'id': id,
            },
        });
    }
    /**
     * @returns Tier OK
     * @throws ApiError
     */
    public static createTier({
        creatorId,
        requestBody,
    }: {
        creatorId: number,
        requestBody: CreateTierForm,
    }): CancelablePromise<Tier> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/{creatorId}/settings/tier',
            path: {
                'creatorId': creatorId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns Tier OK
     * @throws ApiError
     */
    public static listTiers({
        creatorId,
    }: {
        creatorId: number,
    }): CancelablePromise<Array<Tier>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/{creatorId}/settings/tiers',
            path: {
                'creatorId': creatorId,
            },
        });
    }
}
